import cn from 'classnames';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { NAVIGATION_PANEL_DISPLAY_TYPE } from '../../../constants/analytics';

import { NavigationPanelTitle } from './NavigationPanelTitle';

import styles from './NavigationPanel.module.scss';

export function NavigationPanelSection({ prefix, item, path }) {
  const { sections, displayType } = useSelector((state) => state.pageLayout.navigationPanel);
  const { pathname } = useLocation();

  const isCollapsed = (item) => {
    return !get(sections, [...path.split('.'), item.title.toLowerCase()]);
  };

  const isActive = (item) => {
    if (!item.link) return false;
    return pathname === prefix + item.link;
  };

  const renderFirstLevel = (items) => {
    return items.map((item) => (
      <li
        key={item.title}
        className={cn(isActive(item) ? styles.active : '', isCollapsed(item) ? styles.collapsed : '')}
      >
        <NavigationPanelTitle
          item={item}
          isCollapsible={item.items?.length > 0}
          className={styles.firstLevelTitle}
          prefix={prefix}
          path={path}
        />
        {item.items && <ul key={item.title}>{renderSecondLevel(item.items, `${path}.${item.title.toLowerCase()}`)}</ul>}
      </li>
    ));
  };

  const renderSecondLevel = (items, secondLevelpath) => {
    if (!items || displayType === NAVIGATION_PANEL_DISPLAY_TYPE.COMPACT) {
      return null;
    }

    return items.map((item) => (
      <li key={item.title} className={cn(isActive(item) ? styles.active : '', styles.secondLevelTitle)}>
        <NavigationPanelTitle item={item} isCollapsible={false} prefix={prefix} path={secondLevelpath} />
      </li>
    ));
  };

  return (
    <section key={item.title}>
      <NavigationPanelTitle
        item={item}
        isCollapsible={false}
        className={styles.sectionTitle}
        prefix={prefix}
        path={item.title.toLowerCase()}
      />
      <ul key={item.title}>{item.items && renderFirstLevel(item.items)}</ul>
    </section>
  );
}

NavigationPanelSection.propTypes = {
  prefix: PropTypes.string.isRequired,
  item: PropTypes.shape({
    title: PropTypes.string.isRequired,
    link: PropTypes.string,
    items: PropTypes.array,
  }),
  path: PropTypes.string,
};
